export const showDidomiPreferences = () => {
  const didomi = globalThis.Didomi;
  if (didomi) {
    didomi.preferences.show();
  }
};
